export enum MessageType {
  TIMER_PLAY = 'TIMER_PLAY',
  TIMER_PAUSE = 'TIMER_PAUSE',
  TIMER_RESTART = 'TIMER_RESTART',
  TIMER_SYNC_STATE = 'TIMER_SYNC_STATE',
  TIMER_UPDATE = 'TIMER_UPDATE',
  TIMER_ENABLED_CHANGE = 'TIMER_ENABLED_CHANGE',
  TIMER_STATE_REQUEST = 'TIMER_STATE_REQUEST',
  TIMER_STATE_RESPONSE = 'TIMER_STATE_RESPONSE',
  WHITEBOARD_OPEN = 'WHITEBOARD_OPEN',
  WHITEBOARD_CLOSE = 'WHITEBOARD_CLOSE',
  ATHLETE_VIEW_OPEN = 'ATHLETE_VIEW_OPEN',
  ATHLETE_VIEW_CLOSE = 'ATHLETE_VIEW_CLOSE',
  WORKOUT_NEXT = 'WORKOUT_NEXT',
  WORKOUT_PREVIOUS = 'WORKOUT_PREVIOUS',
  SLIDESHOW_CHANGE = 'SLIDESHOW_CHANGE',
  SLIDESHOW_CLOSE = 'SLIDESHOW_CLOSE',
  AUTH_CODE_RECEIVED = 'AUTH_CODE_RECEIVED',
  IFRAME_READY = 'IFRAME_READY',
}

export type MessageTypeKey = keyof typeof MessageType;

export interface AppMessage {
  type: MessageTypeKey;
  url?: string;
  workoutName?: string;
  workoutProgress?: 'completed' | 'aborted';
  elapsedTime?: number;
  timerId?: string;
  isRunning?: boolean;
  slideIndex?: number;
  timestamp?: number;
  isTimerEnabled?: boolean;
  authCode?: string;
  redirectUri?: string;
  userId?: number;
}
